module.exports = __webpack_public_path__ + "img/checkbox.1ce07be4.svg";